var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Box, Center, Container, Image } from '@chakra-ui/react';
import React from 'react';
import { observer } from 'mobx-react';
import { StoreContext } from '../uistore/Rootstore';
import { AppColor } from '../const/AppDefaults';
import wicon from "@/assets/wicon.png";
import { testIsMobile } from '@@/Util';
let Greetings = class Greetings extends React.Component {
    render() {
        const rstore = this.context;
        const appDefaultColour = AppColor.GreetingMessage;
        return (React.createElement(Center, { mb: '50px' },
            React.createElement(Container, null,
                React.createElement(Container, null,
                    React.createElement(Center, null,
                        React.createElement(Box, null,
                            React.createElement(Image, { src: wicon, h: testIsMobile() ? '100px' : '200px', w: testIsMobile() ? '100px' : '200px' })))))));
    }
};
Greetings.contextType = StoreContext;
Greetings = __decorate([
    observer
], Greetings);
export { Greetings };
